export { DetailModal } from './DetailModal';
export type {
  DetailModalAmenity,
  DetailModalLabels,
  DetailModalMoney,
  DetailModalProps,
} from './DetailModal.types';
